// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Cmp404$FrontendWebsite from "../website/components/default/Cmp404.bs.js";
import * as NetworkUtils$FrontendWebsite from "../../utils/NetworkUtils.bs.js";
import * as CircularLoader$FrontendWebsite from "../website/view/components/CircularLoader.bs.js";
import * as TrackLiveTripWrapperComponent$FrontendWebsite from "../track-live-trip/wrapper/TrackLiveTripWrapperComponent.bs.js";

function getWebsiteComponentFromRoute(websiteRoute, country) {
  if (typeof websiteRoute !== "number" && websiteRoute.TAG === /* TrackLiveTrip */2) {
    return React.createElement(React.Suspense, {
                children: React.createElement(TrackLiveTripWrapperComponent$FrontendWebsite.make, {
                      booking_id: websiteRoute._0,
                      customer_uuid: websiteRoute._1
                    }),
                fallback: React.createElement(CircularLoader$FrontendWebsite.make, {})
              });
  }
  NetworkUtils$FrontendWebsite.captureException("404 - Unhandled Route. URL: " + window.location.href);
  return React.createElement(Cmp404$FrontendWebsite.make, {});
}

export {
  getWebsiteComponentFromRoute ,
  
}
/* react Not a pure module */
